<template>
  <div class="solid-background-map-and-hours-component footer-map-component" data-dark-color-is-primary="false"
    data-oem-website-brand="" data-theme="ford" id="solidBackgroundMapAndHoursComponent">
    <div class="map-contact">
      <div class="container-fluid map-contact-container">
        <div class="row flex-row align-items-center">
          <div class="col-xs-12 col-md-6 col-content-map">
            <div class="embed-responsive embed-responsive-16by9"><iframe allowfullscreen="" loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
                src="//www.google.com/maps/embed/v1/place?key=AIzaSyBqmPlt0BmYMsonE4paVkjJjsgW_Bmj-Ic&amp;q=Hometown+Ford+11550+Common+Oaks+Drive+%23204%2C+Raleigh%2C+NC+27614"
                aria-hidden="true" tabindex="-1"></iframe></div>
          </div>
          <div class="col-xs-12 col-md-6 col-content-location-and-hours">
            <div class="content-box">
              <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-12 col-content-location">
                  <div class="row dealer-location-info">
                    <div class="col-xs-12">
                      <h4 class="location-info-heading">Hometown Ford</h4>
                      <p class="location-info-address">11550 Common Oaks Drive #204, Raleigh, NC, 27614</p>
                    </div>
                  </div>
                  <div class="row contact-info">
                    <div class="col-xs-12"><a class="btn contact-link contact-link--directions track-click"
                        data-action="Address Click"
                        href="https://maps.apple.com/?q=Hometown+Ford%2C+11550+Common+Oaks+Drive+%23204%2C+Raleigh%2C+NC%2C+27614"
                        target="_blank"><i aria-hidden="true" class="fa fa-map"></i><span class="sr-only">Get
                          Directions</span></a><a class="btn contact-link contact-link--phone ws-dynamic-number"
                        href="tel:+19198729410"><i aria-hidden="true" class="fa fa-phone"></i><span class="sr-only">Call
                          Us</span></a>
                      <div class="search-bar">
                        <form action="/vehicles" role="search">
                          <div class="input-group"><input aria-label="Search Bar" autocomplete="off" autocorrect="off"
                              class="form-control input-search" data-custom="false" data-placement="bottom"
                              data-search-suggestions="true" data-suggest="true" data-top="2026 Ford F-150" name="query"
                              placeholder="Cars with Navigation" spellcheck="false" title="Search this site..."
                              type="text" value=""><span class="input-group-btn"><button aria-label="search text"
                                class="btn btn-default no-border-left search-submit-btn" type="submit"><i
                                  aria-hidden="true" class="fa fa-search"></i><span
                                  class="alternate-btn-text hidden">Search</span></button><span
                                aria-label="pause automatic search suggest" aria-pressed="false"
                                class="btn btn-default toggleSearchText visuallyhidden" role="button" tabindex="0"><i
                                  aria-hidden="true" class="fa fa-pause"></i></span></span></div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-12 col-content-hours">
                  <div class="row">
                    <div class="col-xs-12 contact-hours">
                      <h5 class="hours-heading">Today's Hours</h5>
                      <p class="current-day-hours"><span class="nav-hour nav-hour--sales"><span
                            class="category-delimiter"></span><span class="category-name">Sales</span><span
                            class="hour hour-open">8 - 7</span></span><span class="nav-hour nav-hour--service"><span
                            class="category-delimiter">•</span><span class="category-name">Service</span><span
                            class="hour hour-open">8 - 7</span></span><span class="nav-hour nav-hour--parts"><span
                            class="category-delimiter">•</span><span class="category-name">Parts</span><span
                            class="hour hour-open">8 - 7</span></span></p><a
                        class="btn utility-link view-all-hours-link" href="/hours"><span
                          class="utility-link-text">Weekly Hours</span><span class="spacer">&nbsp;&nbsp;</span><i
                          aria-hidden="true" class="fa fa-chevron-right"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";

  export default {

  }
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style lang="scss" scoped>
  @import '@/assets/styles/sokal-utility-classes.scss';
  @import '@/assets/styles/sokal-modern-styles.scss';
  @import '@/assets/styles/modern-utility-classes.scss';
  @import '@/assets/styles/sokal_utility_classes_responsive.scss';
</style>

<style type="text/css">

.solid-background-map-and-hours-component {
  --pc: var(--primary-color, #333333);
  --pcd: var(--primary-dark, #000000);
  --pcl: #ffffff;
}

/* Utilities */

.solid-background-map-and-hours-component .btn {
  -moz-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.solid-background-map-and-hours-component .utility-link {
  color: #ffffff;
  color: var(--pcl, #ffffff);
  border: 0;
  border-radius: 0;
  border-bottom: solid 1px;
  border-bottom-color: #ffffff;
  border-bottom-color: var(--pcl, #ffffff);
  padding: 5px 0;
}

.solid-background-map-and-hours-component .utility-link:hover,
.solid-background-map-and-hours-component .utility-link:active,
.solid-background-map-and-hours-component .utility-link:focus {
  opacity: 0.7;
}

.solid-background-map-and-hours-component .flex-row {
  display: flex;
  flex-flow: row-reverse wrap;
}

.solid-background-map-and-hours-component .align-items-center {
  align-items: center;
}

/* General */

.solid-background-map-and-hours-component .map-contact {
  background-color: #333333;
  background-color: var(--pcd);
  color: #ffffff;
  color: var(--pcl, #ffffff);
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.solid-background-map-and-hours-component .map-contact-container {
  max-width: 1400px;
}

.solid-background-map-and-hours-component .map-contact .content-box {
  padding: 30px 0;
  margin: auto;
  max-width: 100%;
}

.solid-background-map-and-hours-component .col-content-map .embed-responsive {
  border-radius: 20px;
}

.solid-background-map-and-hours-component .map-contact h4,
.solid-background-map-and-hours-component .map-contact h5,
.solid-background-map-and-hours-component .map-contact .contact-link {
  text-transform: uppercase;
}

.solid-background-map-and-hours-component .map-contact p,
.solid-background-map-and-hours-component .map-contact .contact-link {
  font-size: 13px;
  font-weight: 400;
}

.solid-background-map-and-hours-component .map-contact .location-info-address {
  margin: 15px 0px;
  font-size: 1.25rem;
  font-family: 'FordF1-Light';
}

.solid-background-map-and-hours-component .map-contact .location-info-heading {
  font-size: 2rem;
  font-family: "FordF1-Semibold";
}

.solid-background-map-and-hours-component .map-contact .hours-heading {
  margin: 15px auto 5px;
  font-size: 2rem;
  text-transform: capitalize;
  font-family: "FordF1-Bold";
}

.col-content-location-and-hours .contact-info .col-xs-12 {
  display: flex;
  align-items: center;
}

.solid-background-map-and-hours-component .map-contact .contact-hours p,
.solid-background-map-and-hours-component .map-contact h4 {
  margin-bottom: 5px;
}

.solid-background-map-and-hours-component .nav-hour,
.solid-background-map-and-hours-component .nav-hour:not(:first-child) .category-delimiter {
  margin-right: 7px;
}

.solid-background-map-and-hours-component .nav-hour {
  display: inline-block;
}

.solid-background-map-and-hours-component .nav-hour .hour {
  font-size: 1.5rem;
  font-family: 'FordF1-Regular';
}

.solid-background-map-and-hours-component .nav-hour .category-name {
  color: #ffffff;
  color: var(--pcl, #ffffff);
  opacity: 1;
  padding-right: 5px;
  font-family: "FordF1-Bold";
  font-size: 1.5rem;
}

.solid-background-map-and-hours-component .contact-link,
.solid-background-map-and-hours-component .search-bar {
  margin-bottom: 10px;
}

.solid-background-map-and-hours-component .contact-link {
  padding: 9px 10px 7px 10px;
  margin-right: 10px;
  color: #ffffff;
  color: var(--pcl, #ffffff);
  border: solid 1px;
  border-color: #ffffff;
  border-color: var(--pcl, #ffffff);
  border-radius: 100%;
  background-color: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(10px);
}

.solid-background-map-and-hours-component .contact-link:hover,
.solid-background-map-and-hours-component .contact-link:active,
.solid-background-map-and-hours-component .contact-link:focus {
  color: #333333;
  color: var(--pc);
  background-color: #ffffff;
  background-color: var(--pcl, #ffffff);
}

.solid-background-map-and-hours-component .contact-link .fa {
  display: inline-block;
  font-size: 22px;
}

.solid-background-map-and-hours-component .view-all-hours-link {
  margin-top: 15px;
  border-bottom: none;
  font-size: 2rem;
  font-family: "FordF1-Semibold";
}

.solid-background-map-and-hours-component .view-all-hours-link .fa {
  font-size: 11px;
}

/* Search Bar */

.solid-background-map-and-hours-component .search-bar {
  display: inline-block;
  vertical-align: middle;
  width: 100%;
}

.solid-background-map-and-hours-component .search-bar .input-group {
  display: flex;
  flex-direction: row-reverse;
}

.solid-background-map-and-hours-component .search-bar .input-group .input-group-btn {
  width: auto;
}

.solid-background-map-and-hours-component .search-bar .input-search {
  background-color: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(10px);
  border-radius: 0 10px 10px 0 !important;
  border-left: none;
  padding-left: 0;
}

.solid-background-map-and-hours-component .search-bar .input-search::placeholder {
  color: #ffffff;
  color: var(--pcl, #ffffff);
}

.solid-background-map-and-hours-component .search-bar .input-group-btn .search-submit-btn {
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(10px);
  color: #ffffff;
  color: var(--pcl, #ffffff);
}

.solid-background-map-and-hours-component .search-bar .input-group-btn .search-submit-btn:hover,
.solid-background-map-and-hours-component .search-bar .input-group-btn .search-submit-btn:active,
.solid-background-map-and-hours-component .search-bar .input-group-btn .search-submit-btn:focus {
  color: #333333;
  color: var(--pc);
  background-color: #ffffff;
  background-color: var(--pcl, #ffffff);
}

.solid-background-map-and-hours-component .search-bar .input-group .form-control:focus,
.solid-background-map-and-hours-component .search-bar .input-group .form-control:focus-visible {
  box-shadow: none;
}

.solid-background-map-and-hours-component .search-bar .input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {
  border-radius: 10px 0 0 10px;
  margin-left: 15px;
  border-right: none;
  z-index: 3;
}

.solid-background-map-and-hours-component .search-bar .input-search,
.solid-background-map-and-hours-component .search-bar button {
  font-size: 14px;
  height: 40px;
  border-color: #ffffff;
  border-color: var(--pcl, #ffffff);
}

@media (min-width: 992px) {

  .solid-background-map-and-hours-component .map-contact .content-box {
    padding: 30px;
    max-width: 460px;
  }

  .col-content-map .embed-responsive-16by9 {
    padding-bottom: 60.25%;
  }

}

@media (min-width: 768px) and (max-width: 991px) {

  .solid-background-map-and-hours-component .map-contact .hours-heading {
    margin-top: 10px;
  }

  .solid-background-map-and-hours-component .view-all-hours-link {
    margin-top: 0;
  }

}

@media (max-width: 991px) {

  .solid-background-map-and-hours-component .nav-hour .category-delimiter {
    display: none;
  }
  .solid-background-map-and-hours-component .flex-row {
    flex-direction: column-reverse;
  }

}

@media (min-width: 1200px) {
  .col-content-map .embed-responsive-16by9 {
    padding-bottom: 50.25%;
  }
}

/* Mazda */

.solid-background-map-and-hours-component[data-oem-website-brand="mazda"] .map-contact {
  background-color: var(--pcd);
}

.visuallyhidden {
    position: absolute !important;
    overflow: hidden !important;
    clip: rect(0 0 0 0) !important;
    height: 1px !important;
    width: 1px !important;
    margin: -1px !important;
    padding: 0 !important;
    border: 0 !important;
}
</style>